import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["Label"], {
        "data-slot": "form-label",
        "data-error": !!$setup.error,
        class: _normalizeClass($setup.cn('data-[error=true]:text-destructive', $setup.props.class)),
        for: $setup.formItemId
    }, {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["data-error", "class", "for"]));
}
